import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";
import type { ChannelShareData } from "../api/types";

interface CallDetailsState {
    callDetails: ChannelShareData;
    setCallDetails: (details: ChannelShareData) => void;
    resetCallDetails: () => void;
}

export const useCallDetailsStore = createWithEqualityFn<CallDetailsState>()(
    persist(
        immer((set) => ({
            callDetails: {},
            setCallDetails: (details) => {
                set((state) => {
                    state.callDetails = details;
                });
            },
            resetCallDetails: () => {
                set((state) => {
                    state.callDetails = {};
                });
            },
        })),
        { name: "call-details-store", skipHydration: true },
    ),
    shallow,
);
